import React from 'react';
import { EventTextProps } from './EventText';
import { FormattedMessage } from 'react-intl';

const EventTextPenaltyGoal: React.FC<EventTextProps> = ({ matchEvent }) => {
  const team = matchEvent?.team?.name;
  const player = matchEvent?.person?.name;

  return (
    <FormattedMessage
      id="eventText.penaltyGoal"
      values={{
        player,
        team,
      }}
    />
  );
};

export default EventTextPenaltyGoal;
